import { atom } from "jotai";
import type { IBlackMediaPlaybackStateInput } from "types/graphqlTypes";

export const PLAYBACK_HEARTBEAT_ATOM = atom<IBlackMediaPlaybackStateInput | null>(null);
// Lives here rather than in `pages/black/index.tsx` so that Fast Refresh doesn't recreate it (and forget who joined)
// whenever the page is edited
export const BLACK_FRIDAY_WAITLIST_JOINED_EMAIL = atom<string | null>(null);
